import { Controller } from "stimulus";
import hideElement from "../../functions/hideElement";
import showElement from "../../functions/showElement";
import disableElement from "../../functions/disableElement";
import enableElement from "../../functions/enableElement";

export default class extends Controller {
  static get targets() {
    return ["checkbox", "hiddenDiv"];
  }

  connect() {
    if (!this.preventInitialCheck) {
      this.checkVisibility();
    }
  }

  checkVisibility() {
    if (this.checkboxTarget.checked) {
      showElement(this.hiddenDivTarget);

      this.hiddenInputs.forEach((field) => {
        enableElement(field);
      });
    } else {
      hideElement(this.hiddenDivTarget);

      this.hiddenInputs.forEach((field) => {
        disableElement(field);
      });
    }
  }

  get preventInitialCheck() {
    return this.element.dataset.preventInitialCheck === "true";
  }

  get hiddenInputs() {
    return [
      ...this.hiddenDivTarget.querySelectorAll("input"),
      ...this.hiddenDivTarget.querySelectorAll("select"),
      ...this.hiddenDivTarget.querySelectorAll("textarea")
    ];
  }
}
